// extracted by mini-css-extract-plugin
export default {"Rating_wrapper_yelp":"k4d6EufLmZ6ZMp4rIPuA","Rating_yelp":"zsOtW4o4qx6BZhNOv6Ne","Rating_yelp_logo":"eo5nUF5RQJOb9K37eYFn","Rating_explanation":"DhYuptgfBkT16ZQd4C0L"};